// @ts-expect-error - Vite PWA plugin virtual module
import { registerSW } from 'virtual:pwa-register'

// Service Worker update handling
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('New version available! Click OK to update.')) {
      updateSW()
    }
  },
  onOfflineReady() {
  },
  onRegistered() {
  },
  onRegisterError() {
  },
})

export { updateSW }